import { type RouteRecordRaw } from 'vue-router';

export default [
  {
    path: '/melco-summit/:barcode',
    name: 'melco.summit',
    meta: {
      requiresAuth: false,
      requires: {
        user: false,
        project: false,
      },
    },
    component: () => import('./pages/MelcoSummitPage.vue'),
  },
  // TODO: remove this route after demo
  {
    path: '/melco-summit-demo',
    name: 'melco-summit-demo',
    meta: {
      layout: 'blank',
      requires: {
        user: false,
        project: false,
      },
      requireProject: false,
    },
    component: () => import('./pages/MelcoSummitDemoPage.vue'),
  },
] as RouteRecordRaw[];
